'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();

  useEffect(() => {
    // Redirect with a query parameter to show toast on dashboard
    router.replace('/?error=page-not-found');
  }, [router]);

  // Return empty div - user will be redirected immediately
  return <div />;
}
